// Obtener descripción del evento (versión corta)
export const EventDescription = (event) => {
  if (event.type === "goal") {
    if (event.eventType === "OG") return "Auto gol";
    return "Gol";
  }
  if (event.eventType === "YC") return "Amarilla";
  if (event.eventType === "RC") return "Roja";
  return "";
};

// Obtener etiqueta del tipo de evento (versión completa para tooltip)
export const getEventTypeLabel = (event) => {
  if (event.type === "goal") {
    if (event.eventType === "OG") return "Auto gol";
    return "Gol";
  }
  if (event.eventType === "YC") return "Tarjeta Amarilla";
  if (event.eventType === "RC") return "Tarjeta Roja";
  return "";
};

export const EventName = (event) => {
  if (event.type === "goal") return event.scorerName || "Gol";
  if (event.type === "card") return event.playerName || "Tarjeta";
  return "";
};

// Obtener clase CSS para el icono (para diferenciar auto goles)
export const getEventIconClass = (event) => {
  if (event.eventType === "G")
    return "icon-amx-gol";
  if (event.eventType === "OG")
    return "icon-amx-gol";
  if (event.eventType === "YC") 
    return "icon-amx-tarjeta amx-card-yellow";
  if (event.eventType === "RC") 
    return "icon-amx-tarjeta amx-card-red";
  if (event.eventType === "substitution") 
    return "icon-amx-cambio";
  return "";
};

// Componente EventIcon
export const EventIcon = ({ event }) => (
  <div className="event-icon">
    <span className={` ${getEventIconClass(event)}`}></span>
  </div>
);
